module.exports = __webpack_public_path__ + "ptc_momoro_R1.66c290d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_R1.jpg
// module id = qz7Q
// module chunks = 0